import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minNumberValidator(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const value = (control.value as string)?.replace(/,/g, '');

    return +value < min ? { minNumber: true } : null;
  }
}
